export default __webpack_public_path__ + "static/media/Hand in trade to earn.6dc5b975.svg";